import Http from '../../shared/Http/Http';
import AWS from 'aws-sdk';
import _ from 'lodash';
import {CognitoUserPool, CognitoUser} from "amazon-cognito-identity-js";
import ConfigResolver from '../../config/ConfigResolver';
import queryString from 'query-string';


export const VERIFY_REGISTRATION = 'VERIFY_REGISTRATION';
export const REGISTRATION_PROCESS_PENDING = 'REGISTRATION_PROCESS_PENDING';
export const CHECK_USER_EXIST_REJECT = 'CHECK_USER_EXIST_REJECT';
export const GET_PROFILE_DATA = 'GET_PROFILE_DATA';
export const EDIT_PROFILE_DATA = 'EDIT_PROFILE_DATA';
export const USER_GET_ME = 'USER_GET_ME';
export const FETCH_USER_BALANCE_FULFILLED = 'FETCH_USER_BALANCE_FULFILLED';
export const FETCH_USER_BALANCE_REJECT = 'FETCH_USER_BALANCE_REJECT';
export const GET_PROFILE_DATA_2FA_SUCCESS = 'GET_PROFILE_DATA_2FA_SUCCESS';
export const GET_PROFILE_DATA_2FA_ERROR = 'GET_PROFILE_DATA_2FA_ERROR';

export const GET_PERMISSION_FETCHING = 'GET_PERMISSION_FETCHING';
export const GET_PERMISSION = 'GET_PERMISSION';
export const GET_PERMISSION_ERROR = 'GET_PERMISSION_ERROR';

export const CHANGE_PASSWORD_PENDING = "CHANGE_PASSWORD_PENDING";
export const CHANGE_PASSWORD_REJECT = "CHANGE_PASSWORD_REJECT";
export const CHANGE_PASSWORD_RESOLVE = 'CHANGE_PASSWORD_RESOLVE';

export const RESSET_LOGIN_ERRORS = 'RESSET_LOGIN_ERRORS';

const {IdentityPoolId, ClientId, UserPoolId, region} = ConfigResolver.config();

export function resetStore(reducerName, resetElem) {
  return {type: `RESET_${reducerName.toUpperCase()}`, resetElem};
}

export function fetchUser(params, cognitoAuth) {
  return (dispatch, currentState) => {
    dispatch({type: "FETCH_USER_PENDING"});


    cognitoAuth.authenticate(params.login.trim().toLowerCase(), params.password, {
      onSuccess: function (authResult) {
        const token = authResult.getAccessToken().getJwtToken();
        const idToken = authResult.getIdToken().getJwtToken();
        const payload = {token, idToken};
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId,
          Logins: {
            [`cognito-idp.${region}.amazonaws.com/${UserPoolId}`]: authResult.getIdToken().getJwtToken()
          }
        });

        AWS.config.credentials.refresh((error) => {
        });

        dispatch({type: "FETCH_USER_FULFILLED", payload});
      },
      onFailure: (err) => {
        console.log(err)
        if (~err.message.indexOf("User is not confirmed.")) {
          dispatch({type: "FETCH_USER_UNCONFIRMED", payload: params.login});
        } else {
          dispatch({type: "FETCH_USER_REJECTED", error: err});
        }
      },
      newPasswordRequired: (userAttributes) => {
        dispatch({type: "RESSET_PASS"});
      }
    })
  }
}

export function cleanLoginErrors() {
  return (dispatch) => {
    dispatch({type: "RESSET_LOGIN_ERRORS"});
  };
}

export function getUser() {
  return async (dispatch, currentState) => {
    dispatch({
      type: 'USER_DATA_FETCHING',
    });
    let params = queryString.parse(currentState().router.location.search);
    AWS.config.region = region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId,
      Logins: {
        [`cognito-idp.${region}.amazonaws.com/${UserPoolId}`]: params.token
      }
    });
    AWS.config.credentials.refresh((error) => {
      if (error) {
        console.error(error);
      } else {
        const {token, accessToken, refreshToken, username} = queryString.parse(currentState().router.location.search);
        localStorage.setItem(`CognitoIdentityServiceProvider.${ClientId}.LastAuthUser`, username);
        localStorage.setItem(`CognitoIdentityServiceProvider.${ClientId}.${username}.accessToken`, accessToken);
        localStorage.setItem(`CognitoIdentityServiceProvider.${ClientId}.${username}.clockDrift`, '1');
        localStorage.setItem(`CognitoIdentityServiceProvider.${ClientId}.${username}.idToken`, token);
        localStorage.setItem(`CognitoIdentityServiceProvider.${ClientId}.${username}.refreshToken`, refreshToken);
        let params = queryString.parse(currentState().router.location.search);
        let adminPermission = params.user;
        dispatch({
          type: 'USER_DATA_FETCHED',
          data: {data: 'data'},
          token: params.token,
          adminPermission
        });
      }
    });

  }
}


export function setRedirectUrl(url) {
  return (dispatch) => {
    dispatch({type: "SET_REDIRECT_URL", payload: url});
  };
}

export function checkUser() { // check somewhere this token
  return (dispatch) => {
    const poolData = {ClientId, UserPoolId};
    const userPool = new CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          localStorage.removeItem('userToken');
          return dispatch({type: "SET_USER_STATE", payload: false}); //valid
        }

        if (session.isValid()) {
          dispatch({type: "SET_USER_STATE", payload: true}); //valid
        }
      });
    }

  };
}

export function setUserLogout() {
  return function (dispatch) {
    const poolData = {ClientId, UserPoolId};
    const userPool = new CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser != null) {
      cognitoUser.signOut();
    }
    localStorage.removeItem("userToken");
    localStorage.removeItem("user");
    localStorage.removeItem('account');
    localStorage.removeItem('mainAccount');
    localStorage.removeItem('distId');
    localStorage.removeItem('accountsNumber');
    localStorage.removeItem('rememberMe');
    dispatch({type: "SET_USER_LOGOUT"});
  };
}

export function sessionExpireLogout(dispatch) {
  const poolData = {ClientId, UserPoolId};
  const userPool = new CognitoUserPool(poolData);
  const cognitoUser = userPool.getCurrentUser();
  if (cognitoUser != null) {
    cognitoUser.signOut();
  }
  localStorage.removeItem("userToken");
  localStorage.removeItem("user");
  localStorage.removeItem('account');
  localStorage.removeItem('mainAccount');
  localStorage.removeItem('distId');
  localStorage.removeItem('accountsNumber');
  localStorage.removeItem('rememberMe');
  dispatch({type: "SET_USER_LOGOUT"});
}

export function resetPassword(data, cognitoAuth) {
  return (dispatch) => {
    dispatch({type: "FORGOT_PASSWORD_PENDING"});
    cognitoAuth.completeNewPasswordChallenge(data.NEW_PASSWORD, null, {
      onSuccess: function (result) {
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId,
          Logins: {
            [`${IdentityPoolId}`]: result.getIdToken().getJwtToken()
          }
        });
      },
      onFailure: (err) => {
        console.log(err);
      }

    });
  }
}

export function userConfirm(body) {
  return dispatch => {
    const url = `/1/user-registration`;
    Http.post(url, body).then((response) => {
      dispatch({
        type: VERIFY_REGISTRATION,
        data: response.data
      });
    })
      .catch((err) => {
        console.log(err);
      });
  }
}

export function getMe() {
  return (dispatch, currentState) => {
    const url = `/me?provider=ipg`;
    Http.get(url, currentState).then((response) => {
      dispatch({
        type: USER_GET_ME,
        data: response.data
      });
    })
      .catch((err) => {
        console.log(err);
      });
  }
}


export function checkSignupStatus(email) {
  return dispatch => {
    const body = {email};
    const url = `/1/check-status`;

    Http.post(url, body).then((response) => {
      dispatch({
        type: VERIFY_REGISTRATION,
        data: response.data
      });
    })
      .catch((err) => {
        console.log(err);
      });
  }
}

export function forgotPassword(email) {
  return function (dispatch, currentState) {
    dispatch({type: "FORGOT_PASSWORD_PENDING"});
    // let state = currentState();
    const poolData = {ClientId, UserPoolId};
    const userPool = new CognitoUserPool(poolData);
    const userData = {
      Username: email,
      Pool: userPool
    };
    const cognitoUser = new CognitoUser(userData);

    cognitoUser.forgotPassword({
      onSuccess: function (result) {
        dispatch({type: "FORGOT_PASSWORD_RESOLVE", payload: {message: 'Check your email.', status: 200}});
      },
      onFailure: function (err) {
        console.log(err);
        dispatch({type: "FORGOT_PASSWORD_REJECT", error: err});
      }
    });
  }
}

export function forgotPasswordConfirm(data) {
  return function (dispatch, currentState) {
    dispatch({type: "FORGOT_PASSWORD_PENDING"});
    const poolData = {ClientId, UserPoolId};
    const userPool = new CognitoUserPool(poolData);
    const userData = {
      Username: data.email,
      Pool: userPool
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmPassword(data.code, data.newPassword, {
      onSuccess: function (result) {
        dispatch({
          type: "NEW_PASSWORD_VERIFY_RESOLVE",
          payload: {message: 'Password has been successfully changed', status: 200}
        });
      },
      onFailure: function (err) {
        console.log(err);
        dispatch({type: "NEW_PASSWORD_VERIFY_REJECT", error: err});
      }
    });
  }
}

export function checkUserExist(type, data) {
  return dispatch => {
    let body = {
      type,
      data: _.trim(data),
    };
    const url = '/1/verif-email';
    Http.autocomplete(url, body).then((response) => {
      dispatch({
        type: REGISTRATION_PROCESS_PENDING,
        payload: response.data
      });
    })
      .catch((err) => {
        console.log(err);
      });
  }
}

export function submit2fa(data) {
  // debugger;
  return async (dispatch, currentState) => {
    const token = await refreshAccessToken();
    const url = '/3/mfa/verify';
    Http.post(url, data, currentState, undefined, token).then((response) => {
      dispatch({
        type: GET_PROFILE_DATA_2FA_SUCCESS,
        data: response.data
      });
    })
      .catch((err) => {
        // console.log(err);
        dispatch({
          type: GET_PROFILE_DATA_2FA_ERROR,
          data: 'error'
        });
      });
  }
}

export function getProfileData() {
  // debugger;
  return async (dispatch, currentState) => {
    const token = await refreshAccessToken();
    const url = '/1/get-user';
    Http.get(url, currentState, undefined, token).then((response) => {
      dispatch({
        type: GET_PROFILE_DATA,
        data: response.data
      });
    })
      .catch((err) => {
        // console.log(err);
      });
  }
}

export function editProfileData(data) {
  return async (dispatch, currentState) => {
    const token = await refreshAccessToken();
    const url = '/1/edit-user';
    Http.post(url, data, currentState, undefined, token).then((response) => {
      dispatch({
        type: EDIT_PROFILE_DATA,
        data: response.data
      });
    })
      .catch((err) => {
        // console.log(err);
      });
  }
}

export function fetchUserBalance() {
  let distId = localStorage.getItem('distId');
  return async (dispatch, currentState) => {
    const token = await refreshAccessToken();
    const url = `/1/get-balance/?distId=${encodeURIComponent(distId)}`;

    Http.get(url, currentState, undefined, token)
      .then((response) => {
        dispatch({
          type: FETCH_USER_BALANCE_FULFILLED,
          payload: response.data
        });
      })
      .catch((err) => {
        // console.log(err);
        dispatch({
          type: FETCH_USER_BALANCE_REJECT,
          error: err.response.data
        });
      });

  }
}

const refreshAccessToken = () => {
  return new Promise((resolve, reject) => {
    const poolData = {ClientId, UserPoolId};
    const userPool = new CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser();
    cognitoUser.getSession((err, session) => {
      if (err) {
        localStorage.removeItem('userToken');
        reject(err);
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
};

export const getNewToken = () => {
  return new Promise((resolve, reject) => {
    const poolData = {ClientId, UserPoolId};
    const userPool = new CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser();
    cognitoUser.getSession((err, session) => {
      if (err) {
        localStorage.removeItem('userToken');
        reject(err);
      }
      const token = session.getAccessToken().getJwtToken();
      resolve(token);
    });
  });
};

export function changeUserPassword(editedData) {
  return async (dispatch, currentState) => {
    dispatch({type: 'CHANGE_PASSWORD_PENDING'});
    const {oldPassword, newPassword, repeatPassword} = editedData;
    try {
      let state = currentState();

      const poolData = {ClientId, UserPoolId};

      const userPool = new CognitoUserPool(poolData);
      const user = userPool.getCurrentUser();
      // const cognitoUser = new CognitoUser(userPool);
      const cognitoUser = await getUserSessionPromise(user);
      cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
        if (err) {
          // console.log(err);
          dispatch({type: CHANGE_PASSWORD_REJECT, err: err});
          return;
        }
        dispatch({type: CHANGE_PASSWORD_RESOLVE, payload: result});
      });
    } catch (err) {
      // console.log(err)
    }
  }
}

function getUserSessionPromise(cognitoUser) {
  return new Promise((resolve, reject) => {
    cognitoUser.getSession((err, session) => {
      if (err) {
        // console.log(err);
        reject(err);
      }
      if (session.isValid()) {
        resolve(cognitoUser)
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/store/actions/userActions.js